module.exports = __webpack_public_path__ + "static/media/kitty5.b9d6a094.gif";